module.exports = __webpack_public_path__ + "img/30.2308c187.png";